export const pokedexGen2 = {
  "pokedex152": "Endivie",
  "pokedex153": "Lorblatt",
  "pokedex154": "Meganie",
  "pokedex155": "Feurigel",
  "pokedex156": "Igelavar",
  "pokedex157": "Tornupto",
  "pokedex158": "Karnimani",
  "pokedex159": "Tyracroc",
  "pokedex160": "Impergator",
  "pokedex161": "Wiesor",
  "pokedex162": "Wiesenior",
  "pokedex163": "Hoothoot",
  "pokedex164": "Noctuh",
  "pokedex165": "Ledyba",
  "pokedex166": "Ledian",
  "pokedex167": "Webarak",
  "pokedex168": "Ariados",
  "pokedex169": "Iksbat",
  "pokedex170": "Lampi",
  "pokedex171": "Lanturn",
  "pokedex172": "Pichu",
  "pokedex173": "Pii",
  "pokedex174": "Fluffeluff",
  "pokedex175": "Togepi",
  "pokedex176": "Togetic",
  "pokedex177": "Natu",
  "pokedex178": "Xatu",
  "pokedex179": "Voltilamm",
  "pokedex180": "Waaty",
  "pokedex181": "Ampharos",
  "pokedex182": "Blubella",
  "pokedex183": "Marill",
  "pokedex184": "Azumarill",
  "pokedex185": "Mogelbaum",
  "pokedex186": "Quaxo",
  "pokedex187": "Hoppspross",
  "pokedex188": "Hubelupf",
  "pokedex189": "Papungha",
  "pokedex190": "Griffel",
  "pokedex191": "Sonnkern",
  "pokedex192": "Sonnflora",
  "pokedex193": "Yanma",
  "pokedex194": "Felino",
  "pokedex195": "Morlord",
  "pokedex196": "Psiana",
  "pokedex197": "Nachtara",
  "pokedex198": "Kramurx",
  "pokedex199": "Laschoking",
  "pokedex200": "Traunfugil",
  "pokedex201": "Icognito",
  "pokedex202": "Woingenau",
  "pokedex203": "Girafarig",
  "pokedex204": "Tannza",
  "pokedex205": "Forstellka",
  "pokedex206": "Dummisel",
  "pokedex207": "Skorgla",
  "pokedex208": "Stahlos",
  "pokedex209": "Snubbull",
  "pokedex210": "Granbull",
  "pokedex211": "Baldorfish",
  "pokedex212": "Scherox",
  "pokedex213": "Pottrott",
  "pokedex214": "Skaraborn",
  "pokedex215": "Sniebel",
  "pokedex216": "Teddiursa",
  "pokedex217": "Ursaring",
  "pokedex218": "Schneckmag",
  "pokedex219": "Magcargo",
  "pokedex220": "Quiekel",
  "pokedex221": "Keifel",
  "pokedex222": "Corasonn",
  "pokedex223": "Remoraid",
  "pokedex224": "Octillery",
  "pokedex225": "Botogel",
  "pokedex226": "Mantax",
  "pokedex227": "Panzaeron",
  "pokedex228": "Hunduster",
  "pokedex229": "Hundemon",
  "pokedex230": "Seedraking",
  "pokedex231": "Phanpy",
  "pokedex232": "Donphan",
  "pokedex233": "Porygon2",
  "pokedex234": "Damhirplex",
  "pokedex235": "Farbeagle",
  "pokedex236": "Rabauz",
  "pokedex237": "Kapoera",
  "pokedex238": "Kussilla",
  "pokedex239": "Elekid",
  "pokedex240": "Magby",
  "pokedex241": "Miltank",
  "pokedex242": "Heiteira",
  "pokedex243": "Raikou",
  "pokedex244": "Entei",
  "pokedex245": "Suicune",
  "pokedex246": "Larvitar",
  "pokedex247": "Pupitar",
  "pokedex248": "Despotar",
  "pokedex249": "Lugia",
  "pokedex250": "Ho-Oh",
  "pokedex251": "Celebi"
};